module.exports = __webpack_public_path__ + "static/img/news111.571259be.png";